import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { createStructuredSelector } from 'reselect';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dashboard from '../../../../component/Dashboard';
import { addMessage, doAddMessageRes } from '../../../../actions/messageAddActions';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import validate from './formValidation';
class AddMessageForm extends React.Component { 
  constructor() {
    super();
    this.state = {
      name: '',
      subject: '',
      body: '',
      short_code: '',
      is_mandatory: true,
      messageDetails: '',
      isSubmited: false,
      tabIndex: 0
    }
  }
  componentDidMount() {
    if (this.props.location.state && this.props.location.state.tabIndex) {
      this.setState({
        tabIndex: this.props.location.state.tabIndex
      });
    }
  }
  static getDerivedStateFromProps(props, state) {
		if (props.addMessageRes) {
      if (props.addMessageRes.data && props.addMessageRes.data.messageAdd) {
        if (props.addMessageRes.data.messageAdd.message === "Success") {
          props.history.push({
            pathname: `/system-setting`,
            state: {
                tabIndex: state.tabIndex,
            }
          });
        }
      }
    }
		return null
	}
  
  goBack = () => {
    this.props.history.push({
      pathname: `/system-setting`,
      state: {
          tabIndex: this.state.tabIndex,
      }
    });
  }
  saveMessage = () => {
    this.setState({
      isSubmited: true,
    }, () => { });
    validate(this.state);
    const errors = validate(this.state);
    
    if (Object.keys(errors).length === 0) {
      let payload = {
        name: this.state.name,
        subject: this.state.subject,
        body: this.state.body,
        short_code: this.state.short_code,
        is_mandatory: this.state.is_mandatory === false ? 0 : 1
      }
      this.props.handleFormSubmit(payload);
    } 
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  
  handleChangeCheckbox = (e) => {
    this.setState({
      [e.target.name]: e.target.checked
    })
  }
  render() {
    const errors = validate(this.state);
    return (
      <Dashboard title="ClickIPO - Add message">
        <div className="admin_offering_content">
          <div className="">
            <div  className="Headingname">
              <ArrowBackIosIcon onClick={() => this.goBack()} style={{ cursor: 'pointer' }} /> Add Message
            </div>
            <form autoComplete="off"  style={{ marginTop: 30 }}>
              <div className="row">
                <div className="col-md-6 col-sm-12"  style={{ marginTop: 20 }}>
                  <TextField name="name" fullWidth label="Name of campaign" onChange={this.handleChange} />
                  {errors && this.state.isSubmited && <span className="errorvalidation">{errors.name}</span>}
                </div>
                <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                  <TextField name="subject" fullWidth label="Subject" onChange={this.handleChange} />
                  {errors && this.state.isSubmited && <span className="errorvalidation">{errors.subject}</span>}
                </div>
                <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                  <TextField name="short_code" fullWidth label="Short Code" onChange={this.handleChange} />
                </div>
                <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                  <TextField multiline name="body" fullWidth label="Body" onChange={this.handleChange} />
                  {errors && this.state.isSubmited && <span className="errorvalidation">{errors.body}</span>}
                </div>
                <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                  <FormControlLabel
                    control={<Checkbox checked={this.state.is_mandatory} onChange={this.handleChangeCheckbox} name="is_mandatory" />}
                    label="Is-mandatory"
                  />
                </div>
              </div>
            </form>
            <div className="row">
              <div className="col-md-12" style={{ textAlign: 'center' }}>
                <Button variant="contained" color="primary" onClick={this.saveMessage} style={{ marginTop: '30px' }} >Save</Button>
              </div>
            </div>
          </div>
        </div>
      </Dashboard>
    );
  }
}

AddMessageForm.propTypes = {
  addMessageRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  addMessageRes: doAddMessageRes,
});

function mapDispatchToProps(dispatch) {
  return {
    handleFormSubmit: (data) => dispatch(addMessage(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMessageForm);
